import React from 'react';
import AddFormModal from './../../common/AddFormModal'
import EdiTable from '../../common/EdiTable'
import Panel from '../../common/layout/Panel'

export default class extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            url: '/admin/products/calleridgroups',
            data: {
                data: [],
                metadata: []
            },
            metadata:
                [
                    {
                        'label': 'id',
                        'source': 'ATRCALLERIDCODEBANDID',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label': 'Caller ID Group Name',
                        'source': 'ATRNAME',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'New caller ID group...'
                    },
                    {
                        label: 'View',
                        value: '/products/calleridgroups/{$id}',
                        type: 'link'
                    },
                    {
                        'label' : 'Actions',
                        'type': 'action_buttons'
                    }
                ]
        }
    }
    componentDidMount() {
        this.setState({data: this.props.data});
    }
    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data) {
            this.setState({data: this.props.data});
        }
    }
    onRowAdded(data) {
        var newdata = this.state.data;
        newdata.data.push(data);
        this.setState({data: newdata});
    }
    render(){
        return(
            <Panel title = "Product Caller ID Groups">
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12">
                                <AddFormModal
                                    bsStyle="add"
                                    addButton="true"
                                    addButtonValue="Add Caller ID Group"
                                    metadata={this.state.metadata}
                                    url={this.state.url}
                                    urlattrs={this.props.urlattrs}
                                    remotemeta={this.state.data.metadata}
                                    onRowAdded={this.onRowAdded.bind(this)}
                                    childProps={this.props.childProps}

                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <EdiTable
                                    data={this.state.data}
                                    metadata={this.state.metadata}
                                    url={this.state.url}
                                    urlattrs={this.props.urlattrs}
                                    childProps={this.props.childProps}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Panel>
        )
    }
}

